import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClockInPending(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="176"
      height="120"
      viewBox="0 0 176 120"
      fill="none"
      {...props}
    >
      <circle cx="88" cy="60" r="45" stroke="url(#paint0_linear_14554_19189)" strokeWidth="10" />
      <path d="M88 32L88 60L103 44" stroke="#0C1C43" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient
          id="paint0_linear_14554_19189"
          x1="88"
          y1="10"
          x2="88"
          y2="110"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#98CCFB" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClockInPending);
export default ForwardRef;
